module.exports = __webpack_public_path__ + "static/media/schedule.5bdb7161.svg";